function show_overlay(additional_class = false){
    $('main').css('filter', 'blur(3px)');
    let overlay = $('.overlay');

    if(additional_class){
        overlay.addClass(additional_class);
    }
    overlay.stop().fadeIn('fast');
}

function hide_overlay(){
    $('.overlay').stop().attr('class', 'overlay').fadeOut('fast');
    $('main').css('filter', 'none');
    $('.js-search-suggest-wrapper').fadeOut();
}

$(document).ready(function(){

    $('.overlay').click(function(){
        hide_overlay();
        mobile_menu_close(1);
        mobile_menu_close(2);
    });

    if ($(window).width() > 991) {
        $('nav > ul > li.menu-item-has-children').hover(function () {
            show_overlay();
        }, function () {
            hide_overlay();
        });
    }

    $('nav li a').click(function(){
        let href = $(this).attr('href');
        if(href){
            let href_without_hash = href.substring(0,href.indexOf('#'));
            let url = new URL(location.href);
            url.hash = '';
            url.search = '';
            if(href_without_hash === url.href){
                mobile_menu_close(1);
                let href_hash = href.substring(href.indexOf('#'));
                scrollTo($(href_hash));
                return false;
            }
        }
    })
});
